var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"py-3"},[(Array.isArray(_vm.campaigns) && _vm.campaigns.length > 0)?_c('ResultsContainer',{attrs:{"rows":_vm.campaigns,"fields":_vm.campaignFields,"hide-totals":""},on:{"goToCampaign":function($event){return _vm.goToCampaign($event)}}}):_c('Spinner',{attrs:{"text":"Loading campaigns..."}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }